export const useReceptionPhotoStore = defineStore('reception-photo', () => {
	const loading = reactive({
		addReceptionPhoto: false
	});

	function $reset() {}

	const getReceptionPhotoByVirtualCargo = async (payload: { virtualCargoId: string }) => {
		const { data, status } = await useCustomFetch<any>(
			'/api/ReceptionPhoto/get-by-virtual-cargo',
			{
				method: 'get',
				query: payload
			},
			{}
		);

		if (status.value === 'success' && data.value) {
		}
		return { data: data.value, status: status.value };
	};

	const uploadReceptionPhoto = async (payload: { virtualCargoId: string; files: any }) => {
		const formData = new FormData();

		formData.append('virtualCargoId', payload.virtualCargoId);
		payload.files.forEach((f) => {
			formData.append('files', f);
		});

		const { data, status } = await useCustomFetch<{ status: boolean; msg: string }>(
			'/api/ReceptionPhoto/upload',
			{
				method: 'POST',
				body: formData
			},
			{
				setLoading: (load: boolean) => {
					if (true) {
						loading.addReceptionPhoto = load;
					}
				}
			}
		);

		if (status.value === 'success' && data.value) {
		}
		return { data: data.value, status: status.value };
	};

	const receptionPhotoDelete = async (payload: { id: string; virtualCargoId: string }) => {
		const { data, status } = await useCustomFetch<any>(
			'/api/ReceptionPhoto/delete',
			{
				method: 'delete',
				query: payload
			},
			{}
		);

		if (status.value === 'success' && data.value) {
		}
		return { data: data.value, status: status.value };
	};

	return {
		loading,
		$reset,
		getReceptionPhotoByVirtualCargo,
		uploadReceptionPhoto,
		receptionPhotoDelete
	};
});
